import { Path } from "@constellation-academy/epic-ui";
import { DiscountCodePath } from "../discount-code/discount-code.paths";

export class DiscountActionEditPath extends Path<typeof DiscountActionEditPath> {
	static readonly pathKey = "edit";
	static readonly childPaths = [DiscountCodePath];
}
